import { Component, Input, OnInit } from '@angular/core';
import { DataService } from 'src/app/shared/services/data.service';
import { tableData } from './table-data';
import { environment } from 'src/environments/environment';
import { StudentDataType } from 'src/app/models/enums/StudentDataType';

@Component({
  selector: 'app-recently-accepted',
  templateUrl: './recently-accepted.component.html',
  styleUrls: ['./recently-accepted.component.scss', './recently-accepted.component.en.scss']
 
})
export class RecentlyAcceptedComponent implements OnInit {
  displayedColumns: string[] = ['courseName', 'informationName', 'timeDetails', 'grade', 'moreOptions'];
  // dataSource = tableData;
  updatedDataSource!: any;
   compare="compare";
  constructor(private dataService: DataService){}
  ngOnInit(): void {
    this.dataService.updateGeneralSettingsData$.subscribe((value) => {
      this.generalSettingsData=value;      
    })
    //this.pageNumber=this.data.pageNumber;

    console.log(this.pageData);
    this.isServerError = this.pageData.isTimeoutErrorAppeared;
   }
   studentDataType = StudentDataType;
   generalSettingsData:any;
   isServerError: boolean = false;
   isLoading: boolean = false;
   currentPage=1;
   pageNumber=0;
  //@Input() data: any;
  pageData:any;
  @Input() set data (value:any){
    // console.log("value")
    // console.log(value)
    if(value){
      this.updatedDataSource = value.data;
      //console.log(this.updatedDataSource);
      };
      this.pageData=value;
    }
  loadMoreData() {
    if(this.isLoading) return;
    this.isLoading = true;
    this.currentPage++;
    var url = environment.apiUrl + '/Portal/StudentRecentInformationListViewBlockList/SearchStudentRecentInformationListView';
    var request: any = {
      cultureCode: this.dataService.getCultureCode(),
      pageSize:this.pageData.pageSize,
      currentPage:this.currentPage
    };
  
    this.dataService.getDataByToken(url, request).subscribe({
      next: (responseData) => {
        this.updatedDataSource = [...this.updatedDataSource, ...responseData.resultItems];
        this.isLoading = false;
      },
      error: (e) => {
        console.error(e);
        this.isLoading = false;
        this.isServerError = true;
      },
    });
  }
  getFilteredStudentDataTypes(dataType:any): any[] {
   return this.generalSettingsData.studentDataTypeItems.filter(
      (item:any) => item.studentDataTypeItemData.key == dataType
    );
 
  }
  getDynamicClassName(studentDataType:any): string {
    return `color-student-type-${studentDataType}`;
  }
}
